import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import config from "../data/config.json";

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private http: HttpClient) {}

  //ea08dd1f330c4cfc9e88f9b6cee478b0
  getSubscription(walletId: string, key: string) {
    return this.http.get(
      'https://eg643lmynh.execute-api.us-east-1.amazonaws.com/dev/subscription-info',
      {
        params: new HttpParams()
          .set('walletId', walletId)
          .set('key', key)
          .set('projectName', config.projectName),
      }
    );
  }

  subscribe(data: {
    walletId: string;
    projectName: string;
    email: string;
    notifyOnUnlock: boolean;
    monthlySummary: boolean;
  }) {
    return this.http.post(
      'https://eg643lmynh.execute-api.us-east-1.amazonaws.com/dev/subscribe',
      data
    );
  }

  updateSubscription(data: {
    walletId: string;
    projectName: string;
    key: string;
    notifyOnUnlock: boolean;
    monthlySummary: boolean;
  }) {
    return this.http.post(
      'https://eg643lmynh.execute-api.us-east-1.amazonaws.com/dev/update-subscription',
      data
    );
  }
}
